import React, { useRef, useEffect, useState, useContext } from 'react'
import {
    StatusColors,
    StatusBackgroundColors,
    filterColors,
} from '../../../../utils/StatusColors'
import { FaTimes } from 'react-icons/fa'
import { DefaultTooltip } from '../../../elem/Tooltip'
import { ParameterContext } from '../../../wrappers/ParameterContext'
import {FilterContext} from '../../../wrappers/FilterContext'
import LoadingSpinner from '../../../elem/LoadingSpinner'


const BarFilters = ({
    externalDataItems,
    groups
}) => {

    const [minWidth, setMinWidth] = useState(4)
    const { setClear } = useContext(ParameterContext)
    const {
        filters,
        setFilters,
        statusCount
    } = useContext(FilterContext)

    const ref = useRef(null)

    useEffect(() => {
        if (ref.current) {
            if (
                [...ref.current.children]
                    .map((x) => x.offsetWidth)
                    .reduce((a, b) => a + b, 0) >
                ref.current.offsetWidth + 1
            ) {
                setMinWidth(minWidth - 1)
            }
        }
    }, [ref])

    const handleStatusClick = (e) => {
        const status = Object.keys(StatusColors).filter((status) =>
            e.target.className.includes(status)
        )[0]
        if(status){
            setFilters({...filters, Status: status === filters.Status ? null : status})
        }
    }

    const handleOuterDivClick = (e, filter) => {
        if (
            e.target.className.includes('inner') ||
            e.target.localName === 'h6'
        ) {
        } else {
            if (filter === filters.ActionGroup) {
                setFilters({ ...filters, StateName: null, ActionGroup: null })
            } else {
                setFilters({ ...filters, StateName: null, ActionGroup: filter })
            }
        }
    }

    const handleInnerDivClick = (e, group, filter) => {
        if (filter === filters.StateName) {
            setFilters({ ...filters, ActionGroup: null, StateName: null })
        } else {
            setFilters({ ...filters, ActionGroup: group, StateName: filter })
        }
    }

    const handleCancel = () => {
        setFilters({ ActionGroup: null, StateName: null, Status: null })
        setClear(true)
    }

    const statusClass = (status) =>
        !filters.Status || filters.Status === status
            ? `status ${status}`
            : `status inactive ${status}`

    const innerClass = (state) => {
        return !filters.StateName || filters.StateName === state
            ? 'innerBar'
            : 'innerBar inactive'
    }
    const outerClass = (group) => {
        return !filters.ActionGroup || filters.ActionGroup === group
            ? 'group'
            : 'group inactive'
    }

    const statusBar = Object.keys(StatusColors).map((status) => {
        const statusArr = statusCount.length
            ? statusCount.filter((x) => x.Status === status)
            : externalDataItems.filter((x) => x.Status === status)

        return {
            Status: status,
            Color: StatusColors[status],
            Count: statusArr.length,
        }
    })

    const data = groups.map((group) => {
        const stateArr = externalDataItems
            .filter((x) => x.ActionGroup === group)
            .sort((a, b) => a.StateId - b.StateId)

        const stateGroups = stateArr.length
            ? stateArr.reduce((acc, curr) => {
                  !acc[curr.StateName]
                      ? (acc[curr.StateName] = 1)
                      : acc[curr.StateName]++
                  return acc
              }, {})
            : {}
        return {
            ActionGroup: group,
            Groups: stateGroups,
            Colors: Object.values(stateGroups).length,
            Total: stateArr.length
                ? Object.values(stateGroups).reduce((acc, curr) => acc + curr)
                : 0,
        }
    })
    return (
        <div className="filterSection">
            <div
                className="has-text-light is-size-5 is-right"
                onClick={handleCancel}
                data-tip={`Clear Filters`}
                data-for="cancel"
            >
                <FaTimes />
                <DefaultTooltip id="cancel" place={'top'} />
            </div>
            <div className="actionGroups">
                {!data.length ? <LoadingSpinner/> : data.map((action, i) => {
                    const actionId = i > 0 ? data[i - 1].Colors : 0
                    const states = Object.entries(action.Groups)
                    return (
                        <div
                            className={outerClass(action.ActionGroup)}
                            onClick={(e) =>
                                handleOuterDivClick(e, action.ActionGroup)
                            }
                            key={`${i}_${actionId}`}
                        >
                            <h5 className="title is-6">{action.ActionGroup}</h5>
                            <div className="box">
                                <div
                                    className="outerBar"
                                    ref={
                                        action.ActionGroup === 'Agency'
                                            ? ref
                                            : null
                                    }
                                >
                                    {!states.length && !externalDataItems.length ? <div className="spinnerContainer"><LoadingSpinner size="2em"/></div> : states.length ? (
                                        states.map(
                                            (arr, i) => {
                                                return (
                                                    <div
                                                        className={innerClass(
                                                            arr[0]
                                                        )}
                                                        onClick={(e) =>
                                                            handleInnerDivClick(
                                                                e,
                                                                action.ActionGroup,
                                                                arr[0]
                                                            )
                                                        }
                                                        key={`${action.ActionGroup}_${i}`}
                                                        style={{
                                                            width: `${
                                                                (arr[1] /
                                                                    action.Total) *
                                                                100
                                                            }%`,
                                                            minWidth: `${minWidth}vw`,
                                                            backgroundColor:
                                                                filterColors[
                                                                    i + actionId
                                                                ],
                                                        }}
                                                    >
                                                        <h6 className="is-size-6 has-text-black total">
                                                            {arr[1]}
                                                        </h6>

                                                        <h6 className="is-size-7 has-text-black">
                                                            {arr[0]}
                                                        </h6>
                                                    </div>
                                                )
                                            }
                                        )
                                    ) : (
                                        <div
                                            className="innerBar inactive"
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <h6 className="is-size-6 has-text-black total">
                                                0
                                            </h6>

                                            <h6 className="is-size-7 has-text-black">
                                                None
                                            </h6>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="status is-flex is-flex-direction-column">
                <div className="box is-flex is-flex-direction-row">
                    {statusBar.map((item, i) => (
                        <div
                            onClick={handleStatusClick}
                            className={statusClass(item.Status)}
                            value={item.Status}
                            style={{
                                height: '5vh',
                                width: '20%',
                                backgroundColor:
                                    StatusBackgroundColors[item.Status],
                                color: item.Color,
                            }}
                            key={`${item.Status}_${i}`}
                        >
                            <h6 className={`is-size-6 ${item.Status}`}>
                                {item.Status}:{' '}
                            </h6>
                            <h6 className={`is-size-6 ${item.Status}`}>
                                {' '}
                                {externalDataItems.length ? item.Count : <LoadingSpinner size="1em"/>}
                            </h6>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BarFilters
